<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  // created() {
  //   this.$store.dispatch('loadUser')
  // }
  mounted(){

  },
  components: {

  },
  methods:{

  },
  watch:{

  }
}
</script>
<style lang="scss">
/*@import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";*/
/*@import "../node_modules/ag-grid-community/dist/styles/ag-theme-material.css";*/
/*@import "../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";*/
/*@import "../node_modules/@totalflow4/ag-grid-community/all-modules/dist/styles/ag-grid.css";*/
/*@import "../node_modules/@totalflow4/ag-grid-community/all-modules/dist/styles/ag-theme-balham.css";*/
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  background: #f2f4f7;
  height: 100%;
  overflow: auto !important;
  font-size: 16px;
  font-family: 'Roboto Condensed', Helvetica, Arial, sans-serif;
  // font-family: 'Assistant', Helvetica, Arial, sans-serif;
  a {
    color: #409EFF;
    text-decoration: none;
  }
}

// Input type number
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

// Font
button, input, .ag-theme-balham, .ag-header {
  font-family: 'Roboto Condensed', Helvetica, Arial, sans-serif !important;
  // font-family: 'Assistant', Helvetica, Arial, sans-serif !important;
}

// Tree col padding-left
// Material
.ag-theme-material .ag-ltr .ag-row-group-indent-1 {
  padding-left: 20px;
}
.ag-theme-material .ag-ltr .ag-row-group-indent-2 {
  padding-left: 40px;
}
.ag-theme-material .ag-ltr .ag-row-group-leaf-indent {
  margin-left: 0;
}

.ag-theme-material .ag-cell {
  border: none;
}

// Balham
.ag-theme-balham .ag-ltr .ag-row-group-indent-1 {
  padding-left: 20px;
}
.ag-theme-balham .ag-ltr .ag-row-group-indent-2 {
  padding-left: 40px;
}
.ag-theme-balham .ag-ltr .ag-row-group-leaf-indent {
  margin-left: 0;
}

.ag-theme-balham .ag-cell {
  border: none;
}

// Modal z-index
.el-select-dropdown, .el-picker-panel {
  z-index: 999999 !important;
}

// Modal text-align
.sweet-modal.is-alert .sweet-content {
  text-align: left !important;
}

// Modal width
.sweet-modal {
  max-width: 700px !important;
}

// Progress padding right
.el-timeline-item__wrapper {
  // padding-right: 20px !important;
}

// Wizard width
.vue-form-wizard .wizard-tab-content {
  padding: 30px 0 10px !important;
}
.vue-form-wizard .wizard-card-footer {
  padding: 0 !important;
}

// notifications
.el-notification {
  z-index: 99999 !important;
}

.disabled {
  color: red !important;
}

.pointer {
  cursor: pointer;
}

.text-align-right {
  text-align: right;
}

// modal title width
.sweet-modal .sweet-title .sweet-title-main {
  width: 90% !important;
}

// date picker
.custom-date-picker .el-date-range-picker.has-sidebar {
  width: 796px !important;
}
.custom-date-picker .el-picker-panel__body {
  margin-left: 150px !important;
}
.custom-date-picker .el-picker-panel__sidebar {
  width: 150px !important;
}
.el-picker-panel__footer button:first-child {
  display: none !important;
}

.billing-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  background: #f0f9eb;
  padding: 10px;
  font-size: 12px;
  &__title {
    display: flex;
    align-items: center;
  }
}

.vat-block {
  position: relative;
  border: 2px dashed #ccc;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 5px 10px;
  &__title {
    margin: 0;
  }
  &__icon {
    color: #409EFF;
    font-size: 24px;
    position: absolute;
    top: 5px;
    right: 5px;
    cursor: pointer;
  }
}

.link-terms {
  color: #409EFF;
  cursor: pointer;
}

.el-input.is-disabled .el-input__inner {
  color:#888 !important;
}

// .btn__space-between {
//   display: flex;
//   justify-content: space-between;
// }
.btn {
  &__space-between {
    display: flex;
    justify-content: space-between;
  }
  &__flex-end {
    display: flex;
    justify-content: flex-end;
  }
}

.content {
  overflow:scroll!important;
}

.el-table .cell {
  word-break: break-word !important;
}

.el-select-dropdown {
  max-width: 600px !important;
}

</style>
